<template>
  <table class="pure-table pure-table-striped" width="100%">
    <tbody>
      <tr v-for="speaker in speakers" :key="speaker.id">
        <td class="indicator">
          <speaking-indicator v-show="speaker.status === 'Active'"/>
          <spoken-indicator v-show="speaker.status === 'Spoken'" />
          <withdrawn-indicator v-show="speaker.status === 'Withdrawn'"/>
          <span class="pending-indicator" v-show="speaker.status === 'Pending'"/>
        </td>
        <td class="name">
          <strong>{{speaker.delegate.getName()}}</strong><br/>
          <span class="association">{{speaker.delegate.associationName}}</span>
        </td>
        <td class="actions">
          <button v-show="speaker.status === 'Pending'" class="pure-button button-success" @click="speak(speaker)" :disabled="motion.speakerSpeaking()">Speak</button>
          <button v-show="speaker.status === 'Active'" class="pure-button button-warning" @click="finish(speaker)">Finish</button>
          <button v-show="speaker.status === 'Pending'" class="pure-button button-error" @click="withdraw(speaker)">Withdraw</button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import SpeakingIndicator from '../display/SpeakingIndicator.vue'
import SpokenIndicator from '../display/SpokenIndicator.vue'
import WithdrawnIndicator from '../display/WithdrawnIndicator.vue'

export default {
  name: 'CurrentMotionSpeakers',
  components: {
    SpeakingIndicator,
    SpokenIndicator,
    WithdrawnIndicator
  },
  props: {
    motion: {
      type: Object,
      required: true
    },
    speakers: {
      type: Array,
      required: true
    }
  },
  methods: {
    speak (speaker) {
      this.$emit('speak', speaker)
    },
    finish (speaker) {
      this.$emit('spoken', speaker)
    },
    withdraw (speaker) {
      console.log('withdrawing, firing event')
      this.$emit('withdrawn', speaker)
    }
  }
}
</script>

<style scoped>
.indicator svg {
  width: 20px !important;
}
.pending-indicator {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: solid 1px #bbb;
  border-radius: 50%;
}
.indicator {
  width: 30px;
  text-align: center;
  min-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/control/CurrentMotionSpeakers.vue